// Siparişler sayfası ve sipariş detay sayfası arasında paylaşılan, Ticimax (SOAP/proxy)
// ve Shopify (REST) ham verilerini ortak bir şekle indirgeyen yardımcılar.

// Bu panel ozel/dahili bir kurulumdur; nginx X-Panel-Key dogrulamasi statik
// panel-app/index.html icinde de ayni sekilde istemci tarafinda tutulur.
export const PANEL_KEY = '69cc189637de1fe6455ab233504606758d2c9f3a06388e84';

export const SOURCES = {
  ticimax: {
    label: 'Koza Butik',
    sub: 'Ticimax',
    dot: 'bg-n-amber-9',
    border: 'border-l-n-amber-9',
    badge: 'bg-n-amber-3 text-n-amber-11',
  },
  shopify: {
    label: 'ModaXLarge',
    sub: 'Shopify',
    dot: 'bg-n-teal-9',
    border: 'border-l-n-teal-9',
    badge: 'bg-n-teal-3 text-n-teal-11',
  },
  trendyol_koza: {
    label: 'Koza Butik',
    sub: 'Trendyol',
    dot: 'bg-orange-400',
    border: 'border-l-orange-400',
    badge: 'bg-orange-100 text-orange-800',
  },
  trendyol_modax: {
    label: 'ModaXLarge',
    sub: 'Trendyol',
    dot: 'bg-purple-400',
    border: 'border-l-purple-400',
    badge: 'bg-purple-100 text-purple-800',
  },
};

export const STATUS_BADGE_CLASSES = {
  success: 'bg-n-teal-3 text-n-teal-11',
  pending: 'bg-n-amber-3 text-n-amber-11',
  cancelled: 'bg-n-ruby-3 text-n-ruby-11',
};

const SHOPIFY_FINANCIAL_LABELS = {
  paid: 'Ödendi',
  pending: 'Ödeme Bekliyor',
  refunded: 'İade Edildi',
  partially_refunded: 'Kısmi İade',
  voided: 'İptal Edildi',
  authorized: 'Ön Provizyon',
  partially_paid: 'Kısmi Ödeme',
};
const SHOPIFY_FULFILLMENT_LABELS = {
  fulfilled: 'Gönderildi',
  partial: 'Kısmi Gönderim',
  unfulfilled: 'Hazırlanıyor',
};

export const fetchJson = async url => {
  const response = await fetch(url, { headers: { 'X-Panel-Key': PANEL_KEY } });
  if (!response.ok) throw new Error(`${url} -> HTTP ${response.status}`);
  return response.json();
};

// Siparis notuna ileride yazilmasi planlanan, temsilci/sosyal medya baglamini
// tasiyan yapilandirilmis formati ayristirir. Henuz hicbir siparis bu formatta
// not icermiyor (ozellik aktif degil); bu fonksiyon aktif edildiginde detay
// sayfasinda otomatik olarak gorunecek baglami hazirlar.
// Beklenen format: "[CW] temsilci=Ad Soyad | kanal=Instagram | kullanici=@adsoyad | konusma=<url>"
export const parseAgentContext = note => {
  const empty = { agentName: '', channel: '', handle: '', conversationUrl: '' };
  if (!note) return empty;
  const match = String(note).match(/\[CW\]([^[]*)/);
  if (!match) return empty;
  const data = {};
  match[1].split('|').forEach(pair => {
    const [key, ...rest] = pair.split('=');
    if (key && rest.length)
      data[key.trim().toLowerCase()] = rest.join('=').trim();
  });
  return {
    agentName: data.temsilci || data.agent || '',
    channel: data.kanal || data.channel || '',
    handle: data.kullanici || data.handle || '',
    conversationUrl: data.konusma || data.conversation || '',
  };
};

export const statusBucket = label => {
  const value = (label || '').toString().toLowerCase();
  if (/iptal|iade|cancel|refund|void/.test(value)) return 'cancelled';
  if (
    /teslim|onay|tamam|gönder|gonder|paid|fulfilled|deliver|complete/.test(
      value
    )
  )
    return 'success';
  return 'pending';
};

export const normalizeTicimax = order => ({
  key: `ticimax-${order.id}`,
  source: 'ticimax',
  id: order.id,
  orderNo: order.siparisNo || '',
  customerName: order.musteriAdi || '',
  phone: order.telefon || '',
  // Ticimax'in 'ToplamTutar' alani sadece urun toplami (KDV haric) + kargo'yu
  // tasir; KDV ve kapida odeme hizmet bedeli ayri alanlarda gelir. Musterinin
  // odeyecegi gercek genel toplam icin uçunu de toplamak gerekiyor.
  amount: (order.tutar || 0) + (order.kdv || 0) + (order.kapidaOdeme || 0),
  currency: order.paraBirimi || 'TRY',
  date: order.tarih || '',
  statusLabel: order.durum || '',
  statusBucket: statusBucket(order.durum),
  paymentType: order.odemeTipi || '',
  agentContext: parseAgentContext(order.siparisNotu),
  raw: order,
});

export const normalizeShopify = order => {
  const customer = order.customer || {};
  const address = order.shipping_address || {};
  const customerName =
    [customer.first_name, customer.last_name].filter(Boolean).join(' ') ||
    address.name ||
    '';
  const financialLabel =
    SHOPIFY_FINANCIAL_LABELS[order.financial_status] ||
    order.financial_status ||
    '';
  const fulfillmentLabel =
    SHOPIFY_FULFILLMENT_LABELS[order.fulfillment_status || 'unfulfilled'] ||
    order.fulfillment_status ||
    '';
  const note =
    order.note ||
    (order.note_attributes || []).map(a => `${a.name}: ${a.value}`).join(' | ');
  return {
    key: `shopify-${order.id}`,
    source: 'shopify',
    id: order.id,
    orderNo: order.name || (order.order_number ? `#${order.order_number}` : ''),
    customerName,
    phone: order.phone || address.phone || customer.phone || '',
    amount: parseFloat(order.total_price || '0'),
    currency: order.currency || order.presentment_currency || 'TRY',
    date: order.created_at || '',
    statusLabel:
      [financialLabel, fulfillmentLabel].filter(Boolean).join(' · ') || '—',
    statusBucket: order.cancelled_at
      ? 'cancelled'
      : statusBucket(`${order.financial_status} ${order.fulfillment_status}`),
    paymentType: (order.payment_gateway_names || []).join(', '),
    agentContext: parseAgentContext(note),
    raw: order,
  };
};

const TRENDYOL_STATUS_TR = {
  Created: 'Sipariş Alındı',
  ReadyToShip: 'Hazır',
  Picking: 'Hazırlanıyor',
  Invoiced: 'Faturalandı',
  Shipped: 'Kargoda',
  Delivered: 'Teslim Edildi',
  Cancelled: 'İptal',
  UnDelivered: 'Teslim Edilemedi',
  Returned: 'İade',
  Repack: 'Yeniden Paketleme',
};

const trendyolStatusBucket = s => {
  if (s === 'Delivered') return 'success';
  if (['Cancelled', 'UnDelivered', 'Returned', 'Repack'].includes(s))
    return 'cancelled';
  return 'pending';
};

export const normalizeTrendyol = (
  order,
  sourceKey = 'trendyol_koza',
  correctedCommission = null
) => {
  const addr = order.shipmentAddress || {};
  const lines = order.lines || [];
  // Trendyol'un 'orderDate' alani Turkiye yerel saatini UTC epoch gibi
  // kodluyor (orn. gercek saat 16:00 UTC ise orderDate 19:00'u UTC olarak
  // gosterir) — gercek ana cevirmek icin 3 saat cikariyoruz, aksi halde
  // siparis saati ekranda hep 3 saat ileri gorunur.
  const TR_EPOCH_OFFSET_MS = 3 * 60 * 60 * 1000;
  const dateISO = order.orderDate
    ? new Date(order.orderDate - TR_EPOCH_OFFSET_MS).toISOString()
    : '';
  const customerName = [order.customerFirstName, order.customerLastName]
    .filter(Boolean)
    .join(' ');
  const pkgStatus = order.shipmentPackageStatus || order.status || '';
  return {
    key: `${sourceKey}-${order.id || order.shipmentPackageId}`,
    source: sourceKey,
    id: order.id || order.shipmentPackageId,
    orderNo: String(order.orderNumber || order.id || ''),
    customerName,
    phone: addr.phone || '',
    amount: parseFloat(order.totalPrice || 0),
    currency: order.currencyCode || 'TRY',
    date: dateISO,
    statusLabel: TRENDYOL_STATUS_TR[pkgStatus] || pkgStatus,
    statusBucket: trendyolStatusBucket(pkgStatus),
    paymentType: order.isCod ? 'Kapıda Ödeme' : 'Online Ödeme',
    agentContext: {
      agentName: '',
      channel: '',
      handle: '',
      conversationUrl: '',
    },
    raw: order,
    correctedCommission,
  };
};

export const formatDate = iso => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const pad = n => String(n).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatCurrency = (amount, currency = 'TRY') => {
  const symbol = currency === 'TRY' ? '₺' : currency;
  const value = Number(amount || 0).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${value} ${symbol}`;
};

// Iki farkli kaynagin (Ticimax / Shopify) ham veri yapisini, detay sayfasinin
// tek bir sablonla gosterebilecegi ortak bir sekle indirger.
export const buildOrderDetail = order => {
  if (!order) return null;
  const raw = order.raw;

  if (order.source === 'trendyol_koza' || order.source === 'trendyol_modax') {
    const raw = order.raw;
    const addr = raw.shipmentAddress || {};
    const lines = raw.lines || [];
    const products = lines.map(item => ({
      name: item.productName || '',
      variant: item.merchantSku || '',
      qty: parseInt(item.quantity || 1, 10),
      unitPrice: parseFloat(item.price || 0),
      total: parseFloat(item.price || 0) * parseInt(item.quantity || 1, 10),
      image: (item.images && item.images[0] && item.images[0].url) || '',
      commission: parseFloat(item.commissionFee || 0),
      barcode: item.barcode || '',
      lineStatus:
        TRENDYOL_STATUS_TR[item.orderLineItemStatusName] ||
        item.orderLineItemStatusName ||
        '',
    }));
    // correctedCommission, settlement (Cari Hesap Ekstresi) ile dogrulanmis
    // siparislerde gercek tutari tasir; henuz teslim edilmemis siparislerde
    // ham satir tahminine dusuyoruz ki komisyon satiri her zaman gorunsun.
    const totalCommission =
      order.correctedCommission ??
      products.reduce((s, p) => s + p.commission, 0);
    const grossAmount = parseFloat(raw.grossAmount || 0);
    const totalDiscount = parseFloat(raw.totalDiscount || 0);
    return {
      customer: {
        name: order.customerName,
        phone: addr.phone || '',
        email: raw.customerEmail || '',
      },
      orderInfo: {
        no: String(raw.orderNumber || ''),
        date: order.date,
        status: order.statusLabel,
        statusBucket: order.statusBucket,
        channel:
          order.source === 'trendyol_koza'
            ? 'Trendyol · Koza Butik'
            : 'Trendyol · ModaXLarge',
        paymentType: order.paymentType,
        packagingStatus: raw.shipmentPackageStatus || '',
      },
      products,
      priceSummary: {
        subtotal: grossAmount,
        discount: totalDiscount,
        commission: totalCommission,
        shipping: 0,
        cod: 0,
        total: parseFloat(raw.totalPrice || 0),
        currency: order.currency,
      },
      address: {
        name:
          addr.fullName ||
          [addr.firstName, addr.lastName].filter(Boolean).join(' '),
        phone: addr.phone || '',
        line: [addr.address1, addr.address2].filter(Boolean).join(', '),
        city: [addr.neighborhood, addr.district, addr.city]
          .filter(Boolean)
          .join(' / '),
      },
      cargo: {
        trackingNo: String(raw.cargoTrackingNumber || ''),
        trackingLink: '',
        carrier: raw.cargoProviderName || '',
      },
      agentContext: order.agentContext,
      discountDisplays: raw.discountDisplays || [],
    };
  }

  if (order.source === 'ticimax') {
    const address = raw.adres || {};
    const products = (raw.urunler || []).map(item => ({
      name: item.urunAdi || '',
      variant: item.varyasyon || '',
      qty: item.adet || 0,
      unitPrice: item.birimFiyat || 0,
      total: (item.adet || 0) * (item.birimFiyat || 0),
      image: item.resim || '',
    }));
    return {
      customer: {
        name: raw.musteriAdi || '',
        phone: raw.telefon || '',
        email: raw.email || '',
      },
      orderInfo: {
        no: raw.siparisNo || '',
        date: order.date,
        status: order.statusLabel,
        statusBucket: order.statusBucket,
        channel: raw.kaynakKanal || 'Ticimax',
        paymentType: raw.odemeTipi || '',
        packagingStatus: raw.paketlemeDurumu || '',
      },
      products,
      priceSummary: {
        subtotal: products.reduce((sum, p) => sum + p.total, 0),
        vat: raw.kdv || 0,
        shipping: raw.kargoTutari || 0,
        cod: raw.kapidaOdeme || 0,
        // raw.tutar ('ToplamTutar') = ara toplam + kargo (KDV haric); gercek
        // genel toplam icin KDV ve kapida odeme bedelini de eklemek gerekir.
        total: (raw.tutar || 0) + (raw.kdv || 0) + (raw.kapidaOdeme || 0),
        currency: order.currency,
      },
      address: {
        name: address.alici || '',
        phone: address.telefon || '',
        line: address.adres || '',
        city: [address.ilce, address.il].filter(Boolean).join(' / '),
      },
      cargo: {
        trackingNo: raw.kargoTakipNo || '',
        trackingLink: raw.kargoTakipLink || '',
        carrier: raw.kargoFirmasi || '',
      },
      agentContext: order.agentContext,
    };
  }

  // Shopify
  const customer = raw.customer || {};
  const address = raw.shipping_address || {};
  const products = (raw.line_items || []).map(item => ({
    name: item.name || item.title || '',
    variant: item.variant_title || '',
    qty: parseFloat(item.quantity || 0),
    unitPrice: parseFloat(item.price || 0),
    total: parseFloat(item.price || 0) * parseFloat(item.quantity || 0),
    image: (item.image && item.image.src) || '',
  }));
  const shipping = (raw.shipping_lines || []).reduce(
    (sum, line) => sum + parseFloat(line.price || 0),
    0
  );
  const fulfillment = (raw.fulfillments || [])[0] || {};
  return {
    customer: {
      name: order.customerName,
      phone: order.phone,
      email: raw.email || raw.contact_email || customer.email || '',
    },
    orderInfo: {
      no: order.orderNo,
      date: order.date,
      status: order.statusLabel,
      statusBucket: order.statusBucket,
      channel:
        raw.source_name === 'web'
          ? 'Shopify Online Mağaza'
          : raw.source_name || 'Shopify',
      paymentType: order.paymentType,
      packagingStatus: '',
    },
    products,
    priceSummary: {
      subtotal: parseFloat(
        raw.subtotal_price || raw.current_subtotal_price || 0
      ),
      vat: parseFloat(raw.total_tax || 0),
      shipping,
      cod: 0,
      total: parseFloat(raw.total_price || 0),
      currency: order.currency,
    },
    address: {
      name:
        address.name ||
        [address.first_name, address.last_name].filter(Boolean).join(' '),
      phone: address.phone || '',
      line: [address.address1, address.address2].filter(Boolean).join(', '),
      city: [address.city, address.province].filter(Boolean).join(' / '),
    },
    cargo: {
      trackingNo: fulfillment.tracking_number || '',
      trackingLink: fulfillment.tracking_url || '',
      carrier: fulfillment.tracking_company || '',
    },
    agentContext: order.agentContext,
  };
};
